<template>
    <div v-if='when' class='loader'></div>
</template>



<script>
export default {
  name: 'circle-loader',
  props: {
  	when: {
    	type: Boolean,
      default: true
    },
    el : {
      type: [String, Number],
    }
  },
  data() {
  	return {
    	loading: true,
      error: false,
    	users: []
    }
  },/*
  created() {
  	setTimeout(() => {
      fetch('https://jsonplaceholder.typicode.com/users/')
        .then(response => response.json())
        .then(users => this.users = users)
        .catch(() => this.error = true)
        .finally(() => this.loading = false)
    }, 2000)
  }*/
}
</script>

<style>
.loader {
  display: inline-block;
    border: 1vh solid #f3f3f3; /* Light grey */
    border-top: 1vh solid #54c7da; /* Blue */
    border-bottom: 1vh solid lightgrey;
    border-left: 1vh solid lightgrey;
    border-right: 1vh solid lightgrey;
    border-radius: 50%;
    width: 5vh;
    height: 5vh;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

fieldset {
  height: 10vh;
}
</style>


// WEBPACK FOOTER //
// src/components/Circle-loader.vue